// extracted by mini-css-extract-plugin
module.exports = {"shareLinks":"ShareButtons_shareLinks__a36yi","shareLinksItem":"ShareButtons_shareLinksItem__3OoqB","shareLinksIcon":"ShareButtons_shareLinksIcon__0YSkp"};